// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1GQbD","content":"styles_content__1Zf30","list":"styles_list__39YNQ"};